export default __webpack_public_path__ + "static/media/NotoSans-Regular.00d6e679.woff";